import {Component, OnInit, Input, ContentChild, TemplateRef, ChangeDetectorRef} from '@angular/core';
import {ItinerarySettings} from './itinerary-accordion-classes';

declare var $: any;

@Component({
    selector: 'app-itinerary-accordion',
    templateUrl: './itinerary-accordion.component.html',
    styleUrls: ['./itinerary-accordion.component.css']
})
export class ItineraryAccordionComponent implements OnInit {

    [key: string]: any;

    @ContentChild('1') ref1: TemplateRef<any>;
    @ContentChild('2') ref2: TemplateRef<any>;
    @ContentChild('3') ref3: TemplateRef<any>;
    @ContentChild('4') ref4: TemplateRef<any>;
    @ContentChild('5') ref5: TemplateRef<any>;
    @ContentChild('6') ref6: TemplateRef<any>;
    @ContentChild('7') ref7: TemplateRef<any>;
    @ContentChild('8') ref8: TemplateRef<any>;
    @ContentChild('9') ref9: TemplateRef<any>;
    @ContentChild('10') ref10: TemplateRef<any>;
    @ContentChild('11') ref11: TemplateRef<any>;
    @ContentChild('12') ref12: TemplateRef<any>;
    @ContentChild('13') ref13: TemplateRef<any>;
    @ContentChild('14') ref14: TemplateRef<any>;
    @ContentChild('15') ref15: TemplateRef<any>;
    @ContentChild('16') ref16: TemplateRef<any>;

    // settings loaded from caller.
    @Input() itinerarySettings: ItinerarySettings;
    @Input() isOpenOnPageEntry: string;
    @Input() scrollIntoFocusOnPageLoad: boolean;
    @Input() shouldCloseOthers: boolean;

    constructor(private ref: ChangeDetectorRef) {
      this.scrollIntoFocusOnPageLoad = true;
      this.shouldCloseOthers = false;
    }

    ngOnInit() {
        this.ref.detectChanges();
    }

    getTemplateFromName(str: string) {
        return this['ref' + str];
    }

    getDesiredHeightByDevice() {
        const innerwidth = window.innerWidth;
        let desiredHeight = 0.0;
        if (innerwidth < 768 && window.location.pathname.indexOf('faq') > -1) {
            // xs & sm
            desiredHeight = 400; // need 200 for safari/kili accordions, 400 for faq
        } else if (innerwidth < 768 && window.location.pathname.indexOf('faq') < 0) {
            // xs & sm
            desiredHeight = 200; // need 200 for safari/kili accordions, 400 for faq
        } else if (innerwidth >= 768 && innerwidth <= 992) {
            // md
            desiredHeight = 50;
        } else if (innerwidth > 992 && innerwidth <= 1200) {
            // lg
            desiredHeight = 200;
        } else {
            // xl
            desiredHeight = 300;
        }
        return desiredHeight;
    }

    isMobileSize() {
        return document.body.clientWidth <= 500;
    }

    public toggleAccordion(event, entry) {
        entry.isOpened = !entry.isOpened;

        // if (entry.isOpened && this.scrollIntoFocusOnPageLoad) {
        //     const element = document.getElementById(entry.contentId);
        //     const desiredHeight = this.getDesiredHeightByDevice();
        //     setTimeout(() => {
        //         scrollTo(0, element.offsetTop + desiredHeight);
        //     }, 10);
        // }

        // set to true - we only needed this variable for the first run-through
        this.scrollIntoFocusOnPageLoad = true;
    }
}
